export default "__VITE_ASSET__4d62bed0__"